<template>
  <div class="grid-view">
    <div
      v-show="showMainList"
      class="main-content"
      type="primary"
    >
      <lcl-search-bar
        :is-show-created-by="true"
        :is-show-sale-state="true"
        config-id="LclRealList"
        :is-query="true"
        :is-query-price="true"
        :show-currency="true"
        :show-price-no="true"
        :is-surcharge="true"
        :filter="filter"
        @onLevelChanged="onLevelChanged"
        @simSearchItemCallBack="toSimpleQuery"
        @advSearchItemResetCallBack="toAdvancedQuery"
        @onGridRefresh="gridRefresh"
        @reset="rowData=[]"
      >
        <template slot="operations">
          <el-button no="onQuotation" type="primary" @click="onQuotation()">{{ $t('Pricing.Quotation') }}</el-button>
          <el-button no="exportToExcel" type="primary" @click="exportToExcel()">{{ $t('Pricing.Export') }}</el-button>
          <span style="margin-left: 20px">{{ globalMsg }}</span>
        </template>
      </lcl-search-bar>
      <div class="section grid-wrapper">
        <cargo-ag-grid
          :config-module="configModule"
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
        />
      </div>
      <div ref="txtRemark" style="height: 6%; width: 99%" @dblclick="onTxtRemarksDoubleClick()">
        <textarea v-model="txtRemarks" no="txtRemarks" :disabled="true" style="width: 100%; margin-left: 10px; height: 100%;" :title="$t('Pricing.RemarkAreaToolTip')" />
      </div>
    </div>
    <subscribe-dialog v-if="subscribe.visible" :visible="subscribe.visible" @close="onSubscribeClose" />
    <price-dialog
      :is-fcl="false"
      :visible="priceDialog.visible"
      :price="priceDialog.price"
      :level="priceDialog.level"
      @close="onPriceDialogClose"
    />
    <quotation-detail-dialog
      v-if="quotationDetail.visible"
      :visible.sync="quotationDetail.visible"
      :model="quotationDetail.quotation"
      :editing="quotationDetail.isEditing"
      :show-quotation-detail="quotationDetail.showDetail"
    />
  </div>
</template>

<script>
import {
  queryOpenPriceLcls,
  queryByPriceNo
} from '@/api/price/priceLcl'
import { getLoading } from '@/utils/utilBaseElement'
import URL from '@/api/urlTranslator'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { PriceUtils } from '@/class/cargo/model/utils/PriceUtils'
import SubscribeDialog from '../../PriceReal/components/PriceReal/SubscribeDialog'
import PriceDialog from '../../PriceReal/components/PriceReal/PriceDialog'
import StrUtils from '@/utils/StrUtils'
import { TenantUtil } from '@/class/cargo/model/utils/TenantUtil'
import DateUtils from '@/utils/dateUtils'
import LclSearchBar from '@/views/cargo/v0/Price/components/query/lclSearchBar'
import { exportExcel } from '@/utils/tableDataExportUtils'
import { Quotation } from '@/class/model/price/Quotation'
import * as PriceConstant from '@/class/cargo/model/parameters/PriceConstant'
import QuotationDetailDialog from '@/views/cargo/v0/Price/Quotation/components/quotationDetailDialog'
import { getVolumeWeightRatioCode } from '@/class/cargo/model/parameters/VolumeWeightRatio'

export default {
  name: 'LclRealList',
  components: {
    QuotationDetailDialog,
    LclSearchBar,
    PriceDialog,
    SubscribeDialog
  },
  props: {
    showAdv: { type: Boolean, default: true }, // 显示高级查询
    expandAdv: { type: Boolean, default: false }, // 是否初始展开高级查询
    disabled: { type: Boolean, default: () => false }, // 禁用
    isShowCreatedBy: { type: Boolean, default: true }, // 是否显示录入人
    isManageModule: { type: Boolean, default: false },
    showSimple: { type: Boolean, default: true }, // 显示简单UI查询
    isShowContractNo: { type: Boolean, default: false },
    showPriceNo: { type: Boolean, default: false },
    configModule: { type: String, default: '' }
  },
  data() {
    return {
      URL,
      globalMsg: '', // 查询条数和勾选条数显示
      rowData: [],
      proxy: {},
      showLevel: false, // 是否显示运价等级
      authedLevel: 99,
      txtRemarks: '',
      selectedRow: null,
      remarkChange: false,
      targetLevel: 0,
      tenantUtil: null,
      filter: {
        priceNo: null,
        total: 0,
        pol: '',
        pod: '',
        cod: '',
        col: '',
        rod: '',
        rol: '',
        carrier: [],
        region: '',
        polCityCode: '',
        podCityCode: '',
        cmbCreatedBy: 'createdBy',
        createdBy: 0,
        branch: 0,
        txtBookingAgent: '',
        contractNo: '',
        level: '',
        currency: 'USD',
        beginDate: DateUtils.formatStandardDate(new Date()),
        endDate: '',
        direct: false,
        frequency1: false,
        frequency2: false,
        frequency3: false,
        frequency4: false,
        frequency5: false,
        frequency6: false,
        frequency7: false,
        volumeWeightRatio: '',
        destinationAgent: []
      },
      quotationDetail: { // 详情
        quotation: null,
        visible: false,
        isEditing: false,
        showDetail: false
      },
      filterJson: {},
      showDetail: false,
      keyWords: null,
      fullscreenLoading: false,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        onRowDoubleClicked: this.onRowDoubleClicked,
        onRowSelected: this.onRowChecked,
        onRowClicked: this.onRowClickedEvent,
        onSelectionChanged: event => {
          const rows = event.api.getSelectedRows()
          this.globalMsg = rows.length > 0 ? StrUtils.substitute(this.$t('Pricing.selectedCount'), rows.length) : ''
        }
      },
      gridParams: {},
      gridApi: null,
      columnDefs: [
        {
          headerName: ' ', maxWidth: 30, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        { headerName: this.$t('Pricing.PriceNo'), field: 'priceNo', colId: 'priceNo', width: 200,
          tooltipValueGetter: (params) => {
            return PriceUtils.priceNoTipFunc(params.data, this.tenantUtil)
          } },
        {
          headerName: this.$t('Pricing.POL'), field: 'pol', colId: 'pol', width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          },
          tooltipValueGetter: (params) => {
            return params.value
          }
        }, { headerName: this.$t('Pricing.POD'), field: 'pod', colId: 'pod', width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          },
          tooltipValueGetter: (params) => {
            return params.value
          } },
        {
          headerName: this.$t('Pricing.Direct'), field: 'direct', colId: 'direct', width: 70,
          cellRenderer: (params) => {
            return ColumnUtils.boolLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('Pricing.Via'), field: 'via', colId: 'via', width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          },
          tooltipValueGetter: (params) => {
            return params.value
          }
        },
        { headerName: this.$t('Pricing.PriceState'), field: 'priceState', colId: 'priceState', width: 70,
          cellRenderer: (params) => {
            return PriceUtils.priceStateLabelFunc(params.value)
          } },
        { headerName: this.$t('Pricing.PriceTrend'), field: 'trend', colId: 'trend', width: 80,
          cellRenderer: (params) => {
            return PriceUtils.trendLabelFunc(params.value)
          } },
        {
          headerName: this.$t('Pricing.CabinNature'), field: 'share', colId: 'share', width: 80,
          cellRenderer: (params) => {
            return PriceUtils.shareColumnLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('Pricing.RateGrade'), field: 'gradeMin', colId: 'gradeMin', width: 70,
          cellRenderer: (params) => {
            return PriceUtils.gradeMinLabelFunc(params)
          }
        },
        {
          headerName: this.$t('Pricing.EqType'), field: 'eqType', colId: 'eqType', width: 60
        },
        {
          headerName: this.$t('Pricing.CostPrice') + '(TON)', field: 'costWeightPrice', colId: 'costWeightPrice', width: 85,
          cellRenderer: (params) => {
            return PriceUtils.priceColumnLabelFunc_nolimit(params.value)
          },
          cellStyle: (params) => {
            return PriceUtils.setCellColor(params.data, true, params.colDef.field)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.setTooltip(params.data, true, params.colDef.field)
          }
        },
        {
          headerName: this.$t('Pricing.CostPrice') + '(CBM)', field: 'costVolumePrice', colId: 'costVolumePrice', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.priceColumnLabelFunc_nolimit(params.value)
          },
          cellStyle: (params) => {
            return PriceUtils.setCellColor(params.data, true, params.colDef.field)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.setTooltip(params.data, true, params.colDef.field)
          }
        },
        {
          headerName: this.$t('Pricing.ColoaderPrice') + '(TON)', field: 'oneWeightPrice', colId: 'oneWeightPrice', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.priceColumnLabelFunc_nolimit(params.value)
          },
          cellStyle: (params) => {
            return PriceUtils.setCellColor(params.data, true, params.colDef.field)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.setTooltip(params.data, true, params.colDef.field)
          }
        },
        {
          headerName: this.$t('Pricing.ColoaderPrice') + '(CBM)', field: 'oneVolumePrice', colId: 'oneVolumePrice', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.priceColumnLabelFunc_nolimit(params.value)
          },
          cellStyle: (params) => {
            return PriceUtils.setCellColor(params.data, true, params.colDef.field)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.setTooltip(params.data, true, params.colDef.field)
          }
        },
        {
          headerName: this.$t('Pricing.CustomerPrice') + '(TON)', field: 'twoWeightPrice', colId: 'twoWeightPrice', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.priceColumnLabelFunc_nolimit(params.value)
          },
          cellStyle: (params) => {
            return PriceUtils.setCellColor(params.data, true, params.colDef.field)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.setTooltip(params.data, true, params.colDef.field)
          }
        },
        {
          headerName: this.$t('Pricing.CustomerPrice') + '(CBM)', field: 'twoVolumePrice', colId: 'twoVolumePrice', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.priceColumnLabelFunc_nolimit(params.value)
          },
          cellStyle: (params) => {
            return PriceUtils.setCellColor(params.data, true, params.colDef.field)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.setTooltip(params.data, true, params.colDef.field)
          }
        },
        {
          headerName: this.$t('Pricing.MarketPrice') + '(TON)', field: 'threeWeightPrice', colId: 'threeWeightPrice', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.priceColumnLabelFunc_nolimit(params.value)
          },
          cellStyle: (params) => {
            return PriceUtils.setCellColor(params.data, true, params.colDef.field)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.setTooltip(params.data, true, params.colDef.field)
          }
        },
        {
          headerName: this.$t('Pricing.MarketPrice') + '(CBM)', field: 'threeVolumePrice', colId: 'threeVolumePrice', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.priceColumnLabelFunc_nolimit(params.value)
          },
          cellStyle: (params) => {
            return PriceUtils.setCellColor(params.data, true, params.colDef.field)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.setTooltip(params.data, true, params.colDef.field)
          }
        },
        {
          headerName: this.$t('Pricing.VAT'), field: 'sellVat', colId: 'sellVat', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.vatLabelFunc(params.data, params.value, this.targetLevel)
          }
        },
        {
          headerName: this.$t('Pricing.PaymentTerm'), field: 'term', colId: 'term', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.dataGridColumnPaymentFunc(params.value)
          }
        },
        { headerName: this.$t('Pricing.ShippingLine'), field: 'shippingLine', colId: 'shippingLine', width: 200 },
        {
          headerName: this.$t('Pricing.Carrier'), field: 'carrier', colId: 'carrier', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.carrierLabFunc(params.data, params.value)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.carrierTipFunc(params.data)
          }
        },
        { headerName: this.$t('Pricing.Source'), field: 'bookingAgent', colId: 'bookingAgent', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.bookingAgentLabelFunc(params.data, params.value, this.tenantUtil)
          },
          tooltipValueGetter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company,
              'cmpIdx', params.value, this.language)
          } },
        { headerName: this.$t('Pricing.DepartureDay'), field: 'frequency8', colId: 'frequency8', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.frequencyLabelFunc(params.data, 'frequency')
          } },
        {
          headerName: this.$t('Pricing.ClosingDay'), field: 'closingDay', colId: 'closingDay', width: 200
        },
        {
          headerName: this.$t('Pricing.DaysColSea'), field: 'days', colId: 'days', width: 200
        },
        {
          headerName: this.$t('Pricing.ShareCarriers'), field: 'shareCarrier', colId: 'shareCarrier', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.moreCompanyLabelFun(params.value, 'shortName', 'cmpIdx')
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.shareCarrierTipFunc(params.data)
          }
        },
        {
          headerName: this.$t('Pricing.PodRegion'), field: 'podRegion', colId: 'podRegion', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.podRegionLabFunc(params.data.pod)
          }
        },
        {
          headerName: this.$t('Pricing.DestinationDock'), field: 'destinationDock', colId: 'destinationDock', width: 200
        },
        { headerName: this.$t('Pricing.Remarks'), field: 'remarks', colId: 'remarks', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.remarkLabelFunc(params.data, params.value)
          } },
        { headerName: this.$t('Pricing.customSpecs'), field: 'customSpecs', colId: 'customSpecs', width: 200 },
        { headerName: this.$t('Pricing.BeginDateCol'), field: 'beginDate', colId: 'beginDate', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          } },
        { headerName: this.$t('Pricing.EndDateCol'), field: 'endDate', colId: 'endDate', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          } },
        { headerName: this.$t('Pricing.ROD'), field: 'region', colId: 'region', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.regionForPriceFclLabelFunc(params.data)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return ColumnUtils.regionForPriceFclLabelFunc(params.data)
          }
        },
        {
          headerName: this.$t('Pricing.volumeWeightRatio'),
          field: 'volumeWeightRatio',
          colId: 'volumeWeightRatio',
          width: 200,
          valueFormatter: params => getVolumeWeightRatioCode(params.value)['name']
        },
        {
          headerName: this.$t('Pricing.minRateValue'),
          field: 'minRateUnit',
          colId: 'minRateUnit',
          width: 200,
          valueFormatter(params) {
            if (params.data.minRateUnit === '最低价') {
              return params.data.minRateUnit
            } else {
              return (params.data.minRateValue || 0) + '' + params.data.minRateUnit
            }
          }
        },
        {
          headerName: this.$t('Pricing.DestinationAgent'),
          field: 'destinationAgent',
          width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.moreCompanyLabelFun(params.value, 'englishName', 'cmpIdx')
          }
        },
        // 仓库
        {
          headerName: this.$t('Pricing.warehouse'),
          field: 'warehouseVendorCmpIdx',
          width: 200,
          valueFormatter: (params) => {
            const name = this.$i18n.locale === 'zh' ? 'chineseName' : 'englishName'
            return ColumnUtils.moreCompanyLabelFun(params.value + '', name, 'cmpIdx')
          }
        },
        // 仓库名称
        {
          headerName: this.$t('Pricing.WarehouseName'),
          field: 'warehouseName',
          width: 200
        },
        // 仓库地址
        {
          headerName: this.$t('Pricing.WarehouseAddress'),
          field: 'warehouseAddress',
          width: 200
        },
        // 仓库联系人
        {
          headerName: this.$t('Pricing.warehouseContact'),
          field: 'warehouseContact',
          width: 200
        },
        // 仓库地图
        {
          headerName: this.$t('Pricing.WarehouseMap'),
          field: 'mapFile',
          width: 200,
          cellRenderer: params => {
            if (!params.value) {
              return ''
            }
            return `<img src="data:image/jpeg;base64,${params.value}" fit="fill" style="height:25px;" >`
          }
        }
      ],
      subscribe: {
        visible: false
      },
      priceDialog: {
        visible: false,
        level: 99,
        price: null
      }
    }
  },
  computed: {
    showMainList() {
      return !this.showDetail
    },
    language() {
      return this.$store.getters.language === 'zh' ? 'chineseName' : 'englishName'
    }
  },
  watch: {
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      this.tenantUtil = await TenantUtil.getInstance()
      this.authedLevel = this.getAuthedLevel()
    },
    fetchOrderRequirement() {
    },
    getAuthedLevel() {
      if (this.$checkPermission(['PLDA_*_0'])) {
        return 0
      } else if (this.$checkPermission(['PLDA_*_1'])) {
        return 1
      } else if (this.$checkPermission(['PLDA_*_2'])) {
        return 2
      }
      return 99
    },
    // 查询
    toSimpleQuery(data) {
      this.proxy = data
      queryByPriceNo(this.proxy).then((res) => {
        this.rowData = res.data
        this.globalMsg = StrUtils.substitute(this.$t('Pricing.QueryRecords'), this.rowData.length)
        if (this.rowData && this.rowData.length === 0) {
          this.$message.warning(this.$t('Pricing.NoRecord'))
        }
        this.loadingEnd()
      }).catch(() => {
        this.loadingEnd()
      })
    },
    handleQueryData(res) {
      const _resMap = res.data
      this.loadingEnd()
      const isNoRecord = !(_resMap)
      if (isNoRecord || _resMap.hasOwnProperty('Count') && Number(_resMap['Count']) === 0) {
        this.$message.warning(this.$t('Pricing.NoRecord'))
        this.rowData = []
        this.globalMsg = StrUtils.substitute(this.$t('Pricing.QueryRecords'), this.rowData.length)
        return
      }
      const count = Number(_resMap['Count'][0])
      // 只返回部分结果的话，弹窗提醒是否加载更多
      if (PriceUtils.isReturnedPartOfResults(this.proxy.isLimited, count)) {
        const msg = StrUtils.substitute(this.$t('Pricing.MaxQueryCount2'), 300)
        this.$confirm(msg, this.$t('Pricing.Tips'), {
          confirmButtonText: this.$t('Pricing.YesLabel'),
          cancelButtonText: this.$t('Pricing.NoLabel'),
          type: 'info',
          closeOnClickModal: false,
          closeOnPressEscape: false,
          showClose: false
        }).then(() => {
        }).catch(() => {
          this.proxy.isLimited = false
          this.toAdvancedQuery(this.proxy)
          return
        })
      }
      let tenantId = NaN
      let rs = []
      for (const item in _resMap) {
        if (item.indexOf('PL') === 0) {
          tenantId = Number(item.substr(2))
          const rs_tenant = this.getResultsByTenant(_resMap[item], tenantId)
          if (rs_tenant && rs_tenant.length > 0) {
            PriceUtils.recordTenant(rs_tenant, tenantId)
            rs = rs.concat(rs_tenant)
          }
        }
      }
      if (PriceUtils.isReturnedPartOfResults(this.proxy.isLimited, count)) {
        rs.pop()
      }
      this.rowData = rs
      this.globalMsg = StrUtils.substitute(this.$t('Pricing.QueryRecords'), this.rowData.length)
    },
    loadingEnd() {
      this.gridOptions.api.clearFocusedCell()
      this.txtRemarks = ''
      this.fullscreenLoading.close()
    },
    getResultsByTenant(map) {
      let rs = []
      const type = 'R'
      if (map.hasOwnProperty(type)) {
        rs = map[type]
      }
      return rs
    },
    toAdvancedQuery(data) {
      this.proxy = data
      this.fullscreenLoading = getLoading()
      queryOpenPriceLcls(this.proxy).then((res) => { this.handleQueryData(res) }).catch(() => {
        this.fullscreenLoading.close()
      })
    },
    onQuotation() {
      const user = this.$store.getters.userInfo
      if (!user.email || !user.userPhone || !user.fax) {
        this.$message.warning(this.$t('Pricing.PlsInputUserInfo'))
        return
      }
      const pl = this.selectedRow
      if (!pl) {
        this.$message.warning(this.$t('Pricing.noSelectedPrice'))
        return
      }
      if (!pl.active) {
        this.$message.warning(this.$t('Pricing.InactiveRate'))
        return
      }
      if (pl.priceState === 1) {
        this.$message.warning(this.$t('Pricing.SuspendRate'))
        return
      }
      if (pl.priceState === 2) {
        this.$message.warning(this.$t('Pricing.RejectRate'))
        return
      }
      const selectedItems = []
      const ql = PriceUtils.createQuotationLclDetail(pl, this.targetLevel)
      const api = this.gridOptions.columnApi
      ql.departureDay = ColumnUtils.getCellRenderValue(api, pl, 'frequency8')
      selectedItems.push(ql)
      const quotation = new Quotation().fillDefaultValue().getData()
      quotation.beginDate = new Date()
      quotation.endDate = !pl ? new Date() : pl.endDate
      quotation.type = PriceConstant.QUOTATION_LCL
      quotation.quotationLclDetail = selectedItems
      quotation.priceUuid = !pl ? null : (pl.uuid || null)
      quotation.bookingAgent = pl.bookingAgent
      quotation.volumeWeightRatio = pl.volumeWeightRatio
      this.quotationDetail.quotation = quotation
      this.quotationDetail.showDetail = false
      this.quotationDetail.isEditing = true
      this.quotationDetail.visible = true
    },
    onSubscribe() {
      this.subscribe.visible = true
    },
    onSubscribeClose() {
      this.subscribe.visible = false
    },
    onPriceDialogClose() {
      this.priceDialog.visible = false
      this.priceDialog.data = {}
    },
    onLevelChanged(level) {
      this.targetLevel = level
    },
    keyWordBlur() {
      this.simQueryPlaceholder = this.$t('Pricing.priceNoPrompt')
    },
    onRowDoubleClicked(e) {
      console.log('rowclick')
      const data = e.data
      const { showLevel, filter, authedLevel, targetLevel, priceDialog } = this
      if (data) {
        if (showLevel && filter.level && filter.level === '0') {
          if (authedLevel > targetLevel) {
            this.$message.warn(this.$t('Price.YourPermissionIsNotEnough'))
            priceDialog.visible = false
            return
          }
        }
        priceDialog.level = showLevel ? targetLevel : authedLevel === 0 ? 1 : authedLevel
        priceDialog.price = data
        priceDialog.visible = true
      }
    },
    onTxtRemarksDoubleClick() {
      console.log('txtRemarks', this.$refs.txtRemark)
      this.$nextTick(() => {
        this.$refs.txtRemark.style.height = !this.remarkChange ? '30%' : '6%'
        this.remarkChange = !this.remarkChange
      })
    },
    // 行首多选框勾选事件
    onRowChecked(event) {
      if (event.node.isSelected()) {
        this.onRowClickedEvent(event)
      }
    },
    onRowClickedEvent(e) {
      const data = e.data
      this.selectedRow = data
      this.txtRemarks = data.remarks + '\n' + this.$t('Message.ShippingSchedule') + ' ' + PriceUtils.frequencyLabelFunc(data, 'frequency') + '  ' + this.$t('Message.Voyage') + ' ' + data.days
    },
    gridRefresh() {
      this.gridOptions.api.refreshCells({ force: true })
    },
    exportToExcel() {
      const fileName = PriceUtils.getFileName('PriceLCL')
      const selectedRows = this.gridOptions.api.getSelectedRows()
      const rows = selectedRows.length === 0 ? this.rowData : selectedRows
      if (rows.length === 0) {
        this.$message.warning(this.$t('Pricing.NoRecord'))
        return
      }
      // 获取显示列
      const allDisplayedColumns = this.gridOptions.columnApi.getAllDisplayedColumns()
      exportExcel(fileName, rows, [...allDisplayedColumns])
    }
  }
}
</script>
<style lang="scss" scoped>
</style>

